import { Dialog } from "@/components";
import { formatAmount } from "@/lib/utils";

const BudgetBreakdown = ({ open, setOpen, data }: any) => {
  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={
        <div className="text-2xl font-bold text-primary">
          {"Budget Breakdown"}
          <div className="h-1 w-[30%] bg-primary rounded-full" />
        </div>
      }
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-[30px]">
        <div>
          <h3 className="font-semibold">Total Expense</h3>
          <span className="text-sm text-g-400">
            {formatAmount(
              data?.totalExpenseByCategory?.Expense ||
                "0"
            )}
          </span>
        </div>
        <div>
          <h3 className="font-semibold">Total Income</h3>
          <span className="text-sm text-g-400">
            {formatAmount(
              data?.totalExpenseByCategory?.Income || "0"      
            )}
          </span>
        </div>
        <div>
          <h3 className="font-semibold">Liabilities</h3>
          <span className="text-sm text-g-400">
            {formatAmount(
              data?.totalExpenseByCategory?.Liabilities ||"0"
            )}
          </span>
        </div>
        <div>
          <h3 className="font-semibold">Assets</h3>
          <span className="text-sm text-g-400">
            {formatAmount(
              data?.totalExpenseByCategory?.Assets ||"0"
            )}
          </span>
        </div>
      </div>
      <div className="text-primary text-20px font-bold mt-[40px]">
        Total Annual Budget: {formatAmount(
          data?.totalExpenseByCategory?.Expense || "0"
        )}
      </div>
    </Dialog>
  );
};

export default BudgetBreakdown;
